export default {
    global: null,
    private: null
}
  